var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8661",
    "data-name": "Group 8661",
    transform: "translate(6931 -17596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3737",
    "data-name": "Rectangle 3737",
    transform: "translate(-6931 17596)",
    fill: "none",
    stroke: "#aeb0b3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 36,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 35,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8660",
    "data-name": "Group 8660",
    transform: "translate(8.119 -45.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9011",
    "data-name": "Path 9011",
    d: "M17.1,26.485a.5.5,0,0,0,.079.2l2.663-6.728h2.708c-.049.124-.09.233-.135.34q-1.986,4.74-3.97,9.48a.226.226,0,0,1-.246.165c-.8-.007-1.6-.006-2.4,0-.121,0-.172-.029-.2-.154-.668-2.6-1.348-5.2-2.01-7.8",
    transform: "translate(-6937.53 17634.969)",
    fill: "#0052cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9012",
    "data-name": "Path 9012",
    d: "M14.184,21.99a1.352,1.352,0,0,0-.8-.988,12.615,12.615,0,0,0-2.276-.736c-.034-.008-.067-.022-.1-.032v-.071c.024-.2.148-.214.32-.213,1.357.007,2.715,0,4.073,0a1.2,1.2,0,0,1,1.262,1.038q.521,2.747,1.036,5.5",
    transform: "translate(-6938.127 17634.967)",
    fill: "#ffc601"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9013",
    "data-name": "Path 9013",
    d: "M29.513,19.8c.29.048.582.085.869.147s.561.145.84.223c.067.019.131.049.211.08-.15.7-.3,1.391-.446,2.083-.34-.107-.665-.229-1-.311a3.65,3.65,0,0,0-1.828-.046,1.6,1.6,0,0,0-.613.333.57.57,0,0,0-.011.891,3.627,3.627,0,0,0,.644.467c.453.268.929.5,1.377.775a2.727,2.727,0,0,1,1.3,1.559,3.033,3.033,0,0,1-1.175,3.235,4.716,4.716,0,0,1-2.2.828A8.039,8.039,0,0,1,23.8,29.7c-.067-.023-.131-.053-.215-.087.155-.725.308-1.445.465-2.181.1.044.188.079.272.119a5.247,5.247,0,0,0,2.339.51,2.328,2.328,0,0,0,1.082-.241.779.779,0,0,0,.155-1.392,5.43,5.43,0,0,0-.877-.535,7.731,7.731,0,0,1-1.444-.9,2.538,2.538,0,0,1-.415-3.515,3.774,3.774,0,0,1,2.311-1.481c.3-.075.606-.1.909-.154.045-.008.089-.023.133-.035Z",
    transform: "translate(-6935.215 17634.934)",
    fill: "#0052cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9014",
    "data-name": "Path 9014",
    d: "M38.731,29.935H36.35c-.075-.356-.153-.711-.226-1.069-.085-.419-.083-.419-.517-.419-.907,0-1.813,0-2.72,0a.2.2,0,0,0-.229.159c-.136.4-.283.8-.434,1.2-.021.056-.1.13-.148.131-.859.008-1.718.006-2.6.006.022-.063.036-.112.056-.159q1.894-4.526,3.791-9.052a1.178,1.178,0,0,1,1.161-.776h2.159ZM35.61,26.409c-.261-1.249-.516-2.473-.771-3.7l-.04-.005-1.341,3.7Z",
    transform: "translate(-6933.851 17634.969)",
    fill: "#0052cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9015",
    "data-name": "Path 9015",
    d: "M20.042,29.943l2.137-9.982h2.578c-.069.33-.134.647-.2.964q-.939,4.391-1.873,8.784c-.04.187-.107.242-.3.239-.705-.013-1.411,0-2.116,0Z",
    transform: "translate(-6936.036 17634.969)",
    fill: "#0052cc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardIcon);
export default __webpack_public_path__ + "static/media/visa-card-icon.4a4600c69e286c41685947f6dd5eebd2.svg";
export { ForwardRef as ReactComponent };